// src/pages/Dashboard/Admin/SeasonStats/components/SeasonEvolutionChart.jsx

import React, { useMemo } from "react";

import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import { buildEvolutionData } from "../utils/seasonStatsDashboardUtils";

export default function SeasonEvolutionChart({
  comparison = [],
}) {
  const data = useMemo(
    () => buildEvolutionData(comparison),
    [comparison],
  );

  return (
    <section className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="h-1.5 bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

      <div className="p-4 sm:p-5 lg:p-6">
        <p className="text-[11px] uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">
          Évolution
        </p>

        <h2 className="mt-1 text-xl font-bold text-slate-900 dark:text-white">
          Effectifs saison après saison
        </h2>

        <p className="mt-2 text-sm leading-6 text-slate-600 dark:text-slate-300">
          Comparez l’effectif global et la répartition
          garçons / filles.
        </p>

        <div className="mt-6 h-[320px] w-full">
          {data.length === 0 ? (
            <div className="flex h-full items-center justify-center rounded-2xl bg-slate-50 text-sm text-slate-500 dark:bg-slate-800/40 dark:text-slate-400">
              Pas encore assez de données.
            </div>
          ) : (
            <ResponsiveContainer
              width="100%"
              height="100%"
            >
              <LineChart
                data={data}
                margin={{
                  top: 10,
                  right: 20,
                  left: 0,
                  bottom: 0,
                }}
              >
                <CartesianGrid
                  strokeDasharray="3 3"
                  opacity={0.25}
                />

                <XAxis dataKey="season" />

                <YAxis allowDecimals={false} />

                <Tooltip />

                <Legend />

                <Line
                  type="monotone"
                  dataKey="total"
                  name="Adhérents"
                  stroke="#013E8E"
                  strokeWidth={3}
                  activeDot={{ r: 6 }}
                />

                <Line
                  type="monotone"
                  dataKey="male"
                  name="Garçons"
                  stroke="#06B6D4"
                  strokeWidth={2}
                />

                <Line
                  type="monotone"
                  dataKey="female"
                  name="Filles"
                  stroke="#EC4899"
                  strokeWidth={2}
                />
              </LineChart>
            </ResponsiveContainer>
          )}
        </div>
      </div>
    </section>
  );
}